export const SET_CERTIFICATE = "SET_CERTIFICATE"
export const SET_ME = "SET_ME"
export const ACTIVE_LOADING = "ACTIVE_LOADING"
export const SHOW_TOAST = "SHOW_TOAST"
export const SET_DROPDOWN_HEADER = "SET_DROPDOWN_HEADER"
export const LOGOUT = "LOGOUT"
export const SET_TOKEN = "SET_TOKEN"
export const SET_TYPES = "SET_TYPES"
